import { h, Component } from 'preact';
import util from 'preact-util';
import { raceLocalSuffix, raceLocalText } from '../../lib/raceTime';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';
import { QRCodeSVG } from 'qrcode.react';
import md5 from 'crypto-js/md5'
import Hls from 'hls.js';
import { route } from 'preact-router';

import localUtil from '../../lib/util';
import { decorateExternalLinks } from '../../lib/externalLinks';
import { raceTermsOfSaleUrl, buildRaceTermsOfSaleBody } from '../../lib/raceTermsOfSale';
import fields from '../../lib/fields';

import FormFieldsCompact from '../../components/form/fieldsCompact';
import Input from '../../components/form/input';
import ImageScroller from '../../components/imagescroller';
import InspectionStatus from '../../components/inspection/status';
import Sparkline from '../../components/gui/sparkline';

import RaceClassList from '../../components/raceClass/list';
import RaceFileList from '../../components/race/fileList';

import GuiList from '../../components/gui/list';
import DateTileCard from '../../components/gui/dateTileCard';

import NewsList from '../../components/news/list';
import RaceResultList from '../../components/race/resultsMini';
import StreamingList from '../../components/streaming/listMini';
import RaceValidation from '../../components/race/validation';

import ProductList from '../../components/product/list';
import { showSeeAllProductsLink, showGuestBasketButton, shouldLoadGuestCart } from '../../lib/raceShop';
import RaceWeatherSummary from '../../components/race/weatherSummary';
import { appAlert, appConfirm } from '../../lib/dialogs';
import { beginDialogAction } from '../../lib/dialogAction';

function displayImg(img, props, size = '150x') {
    if (typeof img !== 'object') {
        return undefined;
    }
    const imgSrc = `${img.s3XLargeLink}`;
    return imgSrc;
}

const CONTENT_HEIGHT = 600;

@withText(props => ({
    titleText: <Text id='race.title'>Races</Text>,

    infoText: <Text id='race.info'>Info</Text>,
    tvText: <Text id='race.tv-team'>TV Team</Text>,
    tvFreetext: <Text id='race.tv-team'>TV Freetext</Text>,
    programText: <Text id='race.program'>Program</Text>,
    termsText: <Text id='race.terms'>Terms</Text>,
    trackText: <Text id='race.track'>Track</Text>,
    rulesText: <Text id='race.rules'>Rules</Text>,
    priceText: <Text id='race.price'>Prices</Text>,
    qualifyText: <Text id='race.qualify'>Qualifying</Text>,
    checkpointsInfoText: <Text id='race.checkpointsInfo'>Checkpoints Info</Text>,
    veterinaryText: <Text id='race.veterinary'>Veterinary</Text>,
    declarationText: <Text id='race.declaration'>Declaration</Text>,
    emergencyText: <Text id='race.emergency'>Emergency</Text>,
    termsOfSaleText: <Text id='race-class.terms-of-sale'>Terms of sale</Text>,
    termsOfSaleLinkText: <Text id='race.terms-of-sale-link'>Open the terms of sale page</Text>,

    raceStartText: <Text id='race.race-start'>Race start</Text>,
    signupStartText: <Text id='race.signup-start'>Signup start</Text>,
    distanceText: <Text id='race.distance'>Distance</Text>,
    dogsText: <Text id='race.dogs'>Dogs</Text>,
    restText: <Text id='race.rest'>Rest</Text>,
    totalFeeText: <Text id='race.total-fee'>Total fee</Text>,
    signupFeeText: <Text id='race.signup-fee'>Signup fee</Text>,

    resultText: <Text id='race.results-menu'>Results</Text>,
    signedupText: <Text id='race.signups'>Signups</Text>,
    trackingText: <Text id='race.tracking'>Tracking</Text>,
    newsText: <Text id='race.news'>News</Text>,
    liveText: <Text id='race.live'>Live</Text>,
    streamingText: <Text id='race.streaming'>Streaming</Text>,

    signupsText: <Text id='race.signups'>Signups</Text>,
    editRaceText: <Text id='race.edit-race'>Edit race</Text>,
    addRaceResultText: <Text id='race-class.add-race-result'>Add RaceResult</Text>,
    addRaceEventText: <Text id='race-class.add-race-event'>Add Race Event</Text>,
    checkinKioskText: <Text id='race-class.checkin-kiosk'>Checkin Kiosk</Text>,

    raceSignupStartText: <Text id='events.race-signup-start'>Race signup start</Text>,
    raceSignupEndText: <Text id='events.race-signup-end'>Race signup end</Text>,
    dashboardText: <Text id='events.race-signup-dashboard'>Race Dashboard</Text>,
    statisticsText: <Text id='race.statistics'>Statistics</Text>,
    gpsDevicesText: <Text id='race.gps-devices'>GPS Devices</Text>,
    trackingAccessText: <Text id='race.tracking-access'>Tracking Access</Text>,
    tvProducerText: <Text id='race.tv-producer'>TV/Radio Producer</Text>,
    vippsSetupText: <Text id='race.vipps-setup'>Vipps payment: how to apply</Text>,
    reprocessGeofencingText: <Text id='race.reprocess-geofencing'>Reprocess Geofencing</Text>,

    cancelledText: <Text id='race.cancelled'>Cancelled</Text>,
}))
@observer
class RaceDetail extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            infoList: [],
            resultList: [],
            adminList: [],
            reprocessingGeofencing: false,
            reprocessingStatus: null,
            processingRatings: false,
            processingRatingsStatus: null,
        };
        this.ingressRef = null;
        this.mainContainer = null;
    }

    async loadRace(props = this.props) {
        const {
            infoText,
            tvText,
            tvFreetext,
            programText,
            checkpointsInfoText,
            termsText,
            trackText,
            rulesText,
            priceText,
            qualifyText,
            veterinaryText,
            declarationText,
            emergencyText,
            termsOfSaleText,
            termsOfSaleLinkText,
            resultText,
            signedupText,
            trackingText,
            newsText,
            liveText,
            streamingText,
            signupsText,
            editRaceText,
            addRaceResultText,
            addRaceEventText,
            checkinKioskText,
            dashboardText,
            statisticsText,
            gpsDevicesText,
            trackingAccessText,
            tvProducerText,
            vippsSetupText,
        } = this.props;
		const { raceStore, userStore, appState } = props.stores;
        const { language: appStateLanguage } = appState;
        const { id } = props;
        raceStore.setRefreshPage(() => {
            console.log('refreshPage');
            this.loadAll();
        });
        raceStore.updateKeyValue('isRaceAdmin', false);

        raceStore.updateKeyValue('race', {});
        raceStore.updateKeyValue('races', []);
        raceStore.updateKeyValue('raceClassList', []);
        raceStore.updateKeyValue('totalContestants', []);

		await raceStore.load(id, false, { addData: ['raceClassList', 'totalContestants', 'customers'] });
        raceStore.checkRace();
        const { user } = userStore;
        const { language = appStateLanguage } = user;
        raceStore.checkAllPositions(user);
        const { race, raceClassList, customers } = raceStore;
        appState.trackRace('view', race);
        const { hasStarted } = raceStore;
        const currentCustomer = customers?.find(c => c.id === race.customer);
        const infoList = [
            {
                id: 1,
                icon: 'fa-duotone fa-circle-info',
                title: infoText,
                body: (language === 'en' ? race.bodyEn : null) || race.info,
                images: [],
            },
            {
                id: 11,
                icon: 'fa-duotone fa-list',
                title: programText,
                body: (language === 'en' ? race.programEn : null) || race.program,
                images: [],
            },
            {
                id: 12,
                icon: 'fa-duotone fa-tent',
                title: checkpointsInfoText,
                body: (language === 'en' ? race.checkpointsInfoEn : null) || race.checkpointsInfo,
                images: [],
            },
            {
                id: 2,
                icon: 'fa-duotone fa-square-list',
                title: termsText,
                body: (language === 'en' ? race.termsEn : null) || race.terms,
                images: [],
            },
            {
                id: 3,
                icon: 'fa-duotone fa-mountains',
                title: trackText,
                body: (language === 'en' ? race.trackInfoEn : null) || race.trackInfo,
                images: [],
            },
            {
                id: 4,
                icon: 'fa-duotone fa-book-section',
                title: rulesText,
                body: (language === 'en' ? race.rulesEn : null) || race.rules,
                images: [],
            },
            {
                id: 5,
                icon: 'fa-duotone fa-user-doctor',
                title: veterinaryText,
                body: (language === 'en' ? race.veterinaryInfoEn : null) || race.veterinaryInfo,
                images: [],
            },
            {
                id: 6,
                icon: 'fa-duotone fa-trophy',
                title: priceText,
                body: (language === 'en' ? race.pricesEn : null) || race.prices,
                images: [],
            },
            {
                id: 7,
                icon: 'fa-duotone fa-square-check',
                title: qualifyText,
                body: (language === 'en' ? race.qualifyingEn : null) || race.qualifying,
                images: [],
            },
            {
                id: 8,
                icon: 'fa-duotone fa-file-signature',
                title: declarationText,
                body: (language === 'en' ? race.declarationEn : null) || race.declaration,
                images: [],
            },
            {
                id: 9,
                icon: 'fa-duotone fa-exclamation-triangle',
                title: emergencyText,
                body: (language === 'en' ? race.emergencyInfoEn : null) || race.emergencyInfo,
                images: [],
            },
            {
                id: 10,
                icon: 'fa-duotone fa-square-list',
                title: termsOfSaleText,
                // Club text + link to the server-rendered per-race terms page
                // (the URL registered with Vipps), so the section always exists.
                body: buildRaceTermsOfSaleBody({
                    text: (language === 'en' ? currentCustomer?.vippsTermsOfSaleEn : null) || currentCustomer?.vippsTermsOfSale,
                    url: raceTermsOfSaleUrl(appState.apiServer, race.id),
                    linkLabel: termsOfSaleLinkText,
                }),
                images: [],
            },
        ].filter(i => i.body);

        this.setState({
            infoList,
            resultList: [
                {
                    id: 1,
                    icon: 'fa-duotone fa-list',
                    title: race.hasResults && (!race.hideResults || userStore.isAdmin || raceStore.isRaceAdmin)
                        ? ((race.showResults || hasStarted) ? resultText : signedupText)
                        : null,
                    url: `/race/${id}/results`,
                    images: [],
                    danger: race.hideResults && (userStore.isAdmin || raceStore.isRaceAdmin),
                },
                {
                    id: 2,
                    icon: 'fa-duotone fa-map-location-dot',
                    title: (race.hasTracking && (race.showTracking || userStore.isAdmin || raceStore.isRaceAdmin)) ? trackingText : null,
                    url: `/race/${id}/tracking`,
                    images: [],
                },
                {
                    id: 3,
                    icon: 'fa-duotone fa-square-rss',
                    title: race.hasNews ? newsText : null,
                    url: `/race/${id}/news`,
                    images: [],
                },
                {
                    id: 4,
                    icon: 'fa-duotone fa-tv',
                    title: race.showStreaming ? streamingText : null,
                    url: `/race/${id}/streaming`,
                    images: [],
                },
                {
                    id: 5,
                    icon: 'fa-duotone fa-tower-broadcast',
                    title: race.hasLiveFeed ? liveText : null,
                    url: `/race/${id}/live`,
                    images: [],
                },
            ].filter(i => i.title),
            adminList: [
                {
                    id: 1,
                    icon: 'fa-duotone fa-pen',
                    title: editRaceText,
                    url: `/race/${id}/admin/edit`,
                    images: [],
                    // styles: 'background-color: #ff0000;',
                    classNames: 'text-danger',
                },
                {
                    id: 2,
                    icon: 'fa-duotone fa-list',
                    title: signupsText,
                    url: `/race/${id}/admin/signups`,
                    images: [],
                    classNames: 'text-danger',
                },
                {
                    id: 3,
                    icon: 'fa-duotone fa-edit',
                    title: addRaceResultText,
                    url: `/race/${id}/admin/raceresults`,
                    images: [],
                    classNames: 'text-danger',
                },
                {
                    id: 4,
                    icon: 'fa-duotone fa-edit',
                    title: checkinKioskText,
                    url: `/race/${id}/admin/checkinKiosk`,
                    images: [],
                    classNames: 'text-danger',
                },
                {
                    id: 5,
                    icon: 'fa-duotone fa-edit',
                    title: dashboardText,
                    url: `/race/${id}/admin/dashboard`,
                    images: [],
                    classNames: 'text-danger',
                },
                {
                    id: 6,
                    icon: 'fa-duotone fa-edit',
                    title: tvText,
                    url: `/tv/team/${id}`,
                    images: [],
                    classNames: 'text-danger',
                },
                {
                    id: 7,
                    icon: 'fa-duotone fa-edit',
                    title: tvFreetext,
                    url: `/tv/freetext/left`,
                    images: [],
                    classNames: 'text-danger',
                },
                {
                    id: 8,
                    icon: 'fa-duotone fa-chart-line',
                    title: statisticsText,
                    onClick: 'openStats',
                    images: [],
                    classNames: 'text-danger',
                },
                {
                    id: 9,
                    icon: 'fa-duotone fa-satellite-dish',
                    title: gpsDevicesText,
                    url: `/race/${id}/admin/gpsdevices`,
                    images: [],
                    classNames: 'text-danger',
                },
                {
                    id: 10,
                    icon: 'fa-duotone fa-key',
                    title: trackingAccessText,
                    url: `/race/${id}/admin/tracking-access`,
                    images: [],
                    classNames: 'text-danger',
                },
                {
                    id: 11,
                    icon: 'fa-duotone fa-broadcast-tower',
                    title: tvProducerText,
                    url: `/race/${id}/admin/tv-radio-producer`,
                    images: [],
                    classNames: 'text-danger',
                },
                {
                    id: 12,
                    icon: 'fa-duotone fa-mobile-screen-button',
                    title: vippsSetupText,
                    url: `/race/${id}/admin/vipps-setup`,
                    images: [],
                    classNames: 'text-danger',
                },
            ],
            timetrackerList: [
                {
                    id: 1,
                    icon: 'fa-duotone fa-edit',
                    title: addRaceResultText,
                    url: `/race/${id}/admin/raceresults`,
                    images: [],
                    classNames: 'text-danger',
                },
            ],
            raceleaderList: [
                {
                    id: 1,
                    icon: 'fa-duotone fa-edit',
                    title: addRaceResultText,
                    url: `/race/${id}/admin/raceresults`,
                    images: [],
                    classNames: 'text-danger',
                },
                {
                    id: 2,
                    icon: 'fa-duotone fa-edit',
                    title: addRaceEventText,
                    url: `/race/${id}/admin/raceevent`,
                    images: [],
                    classNames: 'text-danger',
                },
            ],
            tvRadioProducerList: [
                {
                    id: 1,
                    icon: 'fa-duotone fa-broadcast-tower',
                    title: tvProducerText,
                    url: `/race/${id}/admin/tv-radio-producer`,
                    images: [],
                    classNames: 'text-danger',
                },
            ],

        });
	}

    async loadRaceClassContestants(props = this.props) {
		const { raceClassContestantStore } = props.stores;
        const { id } = props;

        await raceClassContestantStore.load({
            query: {
                race: id,
            },
            addData: [],
        });
        raceClassContestantStore.getCountries();
    }

    async loadRaceProducts(props = this.props) {
        const { productStore, raceStore, userStore, guestCartStore } = props.stores;
        const { race } = raceStore;
// console.log('loadRaceProducts', race);
        await productStore.load({
            query: {
                customer: race.customer,
                webshop: 1,
            },
            url: `/api/products/public`,
            addData: [],
        });
        // Visitors who are not logged in get a browser basket for this shop
        // (guest checkout with Vipps); see lib/raceShop.js and stores/guestCart.js.
        const { user = {} } = userStore;
        if (guestCartStore && shouldLoadGuestCart({ userId: user.id, raceCustomerId: race.customer })) {
            await guestCartStore.load(race.customer);
            // Back from Vipps (ePayment redirect): show the order result.
            if (guestCartStore.returnedFromVipps) {
                this.openGuestCart();
            }
        }
    }

    openGuestCart = () => {
        const { appState, raceStore } = this.props.stores;
        const { race = {} } = raceStore;
        const { drawerHeightMediumLarge } = appState;
        appState.openDrawer('guestCart', {
            race: race.id,
            height: drawerHeightMediumLarge,
        }, 1);
    }

    loadAll = async (props = this.props) => {
        // console.log('detail.loadAll', props);
        await this.loadRace(props);
        // this.loadRaceClassContestants(props);
        await this.loadRaceProducts(props);
        this.checkIngressHeight();
    }

    viewText = e => {
        // console.log('viewText');
        const { drawerLevel = 1 } = this.props;
        const { id } = e.target.closest('.box-line').dataset;
        // const { id } = e.target.closest('').dataset;

        const { infoList } = this.state;
        const info = infoList.find(i => i.id === parseInt(id, 10));


		const { appState } = this.props.stores;
		const { drawerHeightMedium } = appState;
		appState.openDrawer('viewText', {
			height: drawerHeightMedium,
			title: info.title,
            body: info.body,
            images: info.images,
		}, drawerLevel + 1);
	}


    addToCalendar = e => {
        const {
            raceSignupStartText,
            raceSignupEndText,
            raceStartText,
        } = this.props;
        const { drawerLevel = 1 } = this.props;
        const { raceStore } = this.props.stores;
        const { race = {}, raceClassList } = raceStore;

		const { appState } = this.props.stores;
		const { drawerHeightSmall, apiServer } = appState;
        const events = [];
        if (new Date(race.signupStartDate) > new Date()) {
            events.push(
                {
                    startTime: race.signupStartDate,
                    endTime: race.signupStartDate,
                    title: `${race.title}: ${raceSignupStartText}`,
                    description: race.body ? race.body : '',
                    location: race.location ? race.location : '',
                    url: `${apiServer}/#/race/${race.id}`,
                },
            );
        }
        if (new Date(race.signupEndDate) > new Date()) {
            events.push(
                {
                    startTime: race.signupEndDate,
                    endTime: race.signupEndDate,
                    title: `${race.title}: ${raceSignupEndText}`,
                    description: race.body ? race.body : '',
                    location: race.location ? race.location : '',
                    url: `${apiServer}/#/race/${race.id}`,
                },
            );
        }
        if (new Date(race.endDate) > new Date()) {
            events.push(
                {
                    startTime: race.startDate,
                    endTime: race.endDate,
                    title: `${race.title}: ${raceStartText}`,
                    description: race.body ? race.body : '',
                    location: race.location ? race.location : '',
                    url: `${apiServer}/#/race/${race.id}`,
                },
            );
        }

		appState.openDrawer('addToCalendar', {
			height: drawerHeightSmall,
			// title: 'Add to calendar',
            events,
		}, drawerLevel + 1);
	}

    goToPage = e => {
        const { id } = e.target.closest('.box-line').dataset;
        const { resultList } = this.state;
        const res = resultList.find(i => i.id === parseInt(id, 10));
        if (res.url) {
            route(res.url);
        }
    }

    goToAdminPage = e => {
        const { id } = e.target.closest('.box-line').dataset;
        const { adminList } = this.state;
        const res = adminList.find(i => i.id === parseInt(id, 10));
        if (res.onClick && this[res.onClick]) {
            this[res.onClick]();
        } else if (res.url) {
            route(res.url);
        }
    }

    openStats = () => {
        const { appState, raceStore } = this.props.stores;
        const { drawerHeightLarge } = appState;
        const { race } = raceStore;

        appState.openDrawer('viewRaceStats', {
            height: drawerHeightLarge,
            raceId: race.id,
        }, 1);
    }

    reprocessGeofencing = async () => {
        const dialogAction = beginDialogAction(this, 'reprocessGeofencing', () => [
            this.props?.stores?.raceStore?.race?.id,
        ]);
        if (!dialogAction) return false;
        try {
            const { raceStore } = this.props.stores;
            const { race } = raceStore;

            // Use race's addAutoResultsHidden setting to determine if results should be hidden
            const addAsHidden = race.addAutoResultsHidden ? true : false;
            const hiddenText = addAsHidden ? 'HIDDEN (race setting is ON)' : 'VISIBLE (race setting is OFF)';

            if (!((await appConfirm(`Are you sure you want to reprocess geofencing for race "${race.title}"?\n\nThis will:\n- Delete all existing geofence states\n- Delete all auto-generated race results\n- Reprocess all GPS points in chronological order\n\nResults will be added as: ${hiddenText}`)) && dialogAction.isCurrent())) {
                return;
            }

            this.setState({ reprocessingGeofencing: true, reprocessingStatus: 'Starting...' });

            try {
                // Start the job
                const startResponse = await util.fetchApi('/api/gpspoints/reprocess-geofencing', { method: 'POST' }, {
                    raceId: race.id,
                    addAsHidden,
                });

                if (startResponse.status !== 202) {
                    (await appAlert(`Error: ${startResponse.message || 'Failed to start reprocess job'}`));
                    this.setState({ reprocessingGeofencing: false, reprocessingStatus: null });
                    return;
                }

                const { jobId } = startResponse.data;

                // Poll for status
                let completed = false;
                while (!completed) {
                    await new Promise(resolve => setTimeout(resolve, 2000)); // Wait 2 seconds

                    const statusResponse = await util.fetchApi('/api/gpspoints/reprocess-geofencing', { method: 'POST' }, { jobId });

                    if (statusResponse.status === 200 && statusResponse.data) {
                        const { data } = statusResponse;
                        this.setState({ reprocessingStatus: `${data.phase} (${data.processedPoints || 0}/${data.totalGpsPoints || '?'})` });

                        if (data.status === 'completed') {
                            completed = true;
                            (await appAlert(`Geofencing reprocessed successfully!\n\n- Deleted states: ${data.deletedStates}\n- Deleted auto results: ${data.deletedResults}\n- Processed GPS points: ${data.processedPoints}\n- Skipped (no device): ${data.skippedNoDevice}\n- Errors: ${data.errors}\n- Results added as hidden: ${data.addAsHidden ? 'YES' : 'NO'}`));
                        } else if (data.status === 'error') {
                            completed = true;
                            (await appAlert(`Error: ${data.message}`));
                        }
                    } else {
                        completed = true;
                        (await appAlert(`Error checking status: ${statusResponse.message}`));
                    }
                }
            } catch (err) {
                (await appAlert(`Error: ${err.message}`));
            }

            this.setState({ reprocessingGeofencing: false, reprocessingStatus: null });
        } finally {
            dialogAction.finish();
        }
    }

    processMusherRatings = async () => {
        const dialogAction = beginDialogAction(this, 'processMusherRatings');
        if (!dialogAction) return false;
        try {
            const { raceStore } = this.props.stores;
            const { race } = raceStore;
            const { raceClassList } = race;

            if (!raceClassList || raceClassList.length === 0) {
                (await appAlert('No race classes found for this race.'));
                return;
            }

            if (!((await appConfirm(`Are you sure you want to process musher ratings for race "${race.title}"?\n\nThis will process ${raceClassList.length} race class(es) and update the musher ratings.`)) && dialogAction.isCurrent())) {
                return;
            }

            this.setState({ processingRatings: true, processingRatingsStatus: 'Processing...' });

            try {
                let totalProcessed = 0;
                let totalSkipped = 0;

                for (let i = 0; i < raceClassList.length; i++) {
                    const raceClass = raceClassList[i];
                    this.setState({ processingRatingsStatus: `Processing ${i + 1}/${raceClassList.length}: ${raceClass.title || 'Race class'}...` });

                    const response = await util.fetchApi('/api/musherratings/process-raceclass', { method: 'POST' }, {
                        raceClassId: raceClass.id,
                    });

                    if (response.status === 200) {
                        if (response.data?.success) {
                            totalProcessed++;
                        } else {
                            totalSkipped++;
                        }
                    } else {
                        console.error(`Failed to process race class ${raceClass.id}:`, response.message);
                        totalSkipped++;
                    }
                }

                this.setState({ processingRatingsStatus: null });
                (await appAlert(`Musher ratings processed!\n\nProcessed: ${totalProcessed} race class(es)\nSkipped: ${totalSkipped} race class(es)`));
            } catch (err) {
                (await appAlert(`Error: ${err.message}`));
            }

            this.setState({ processingRatings: false, processingRatingsStatus: null });
        } finally {
            dialogAction.finish();
        }
    }

    goToTimetrackerPage = e => {
        const { id } = e.target.closest('.box-line').dataset;
        const { timetrackerList } = this.state;
        const res = timetrackerList.find(i => i.id === parseInt(id, 10));
        if (res.url) {
            route(res.url);
        }
    }

    goToRaceleaderPage = e => {
        const { id } = e.target.closest('.box-line').dataset;
        const { raceleaderList } = this.state;
        const res = raceleaderList.find(i => i.id === parseInt(id, 10));
        if (res.url) {
            route(res.url);
        }
    }

    goToTvRadioProducerPage = e => {
        const { id } = e.target.closest('.box-line').dataset;
        const { tvRadioProducerList } = this.state;
        const res = tvRadioProducerList.find(i => i.id === parseInt(id, 10));
        if (res.url) {
            route(res.url);
        }
    }

    goToTracking = e => {
        const { id } = this.props;
        route(`/race/${id}/tracking`);
    }

    goToResults = e => {
        const { id } = this.props;
        route(`/race/${id}/results`);
    }

    goToNews = e => {
        const { id } = this.props;
        route(`/race/${id}/news`);
    }

    goToStreaming = e => {
        const { id } = this.props;
        route(`/race/${id}/streaming`);
    }

    goToLive = e => {
        const { id } = this.props;
        route(`/race/${id}/live`);
    }

    sortByTotal = (a, b) => {
        const { raceClassContestantStore } = this.props.stores;
        const { countriesTotal } = raceClassContestantStore;
        return countriesTotal[b] - countriesTotal[a];
    }

    checkIngressHeight = () => {
        if (this.ingressRef) {
            const contentHeight = this.ingressRef.scrollHeight;
            if (contentHeight > CONTENT_HEIGHT) {
                this.setState({
                    ingressHeight: contentHeight,
                    ingressExpanded: false,
                    ingressShowToggleButtons: true,
                });
            }
        }
    }

    componentDidMount() {
        this.loadAll();
        decorateExternalLinks(this.mainContainer);
    }

    componentDidUpdate() {
        decorateExternalLinks(this.mainContainer);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.id !== this.props.id) {
            this.loadAll(nextProps);
        }
    }

    componentWillUnmount() {

    }

    render() {
        const {
            infoList,
            resultList,
            adminList,
            timetrackerList,
            raceleaderList,
            tvRadioProducerList,
            ingressHeight,
            ingressExpanded,
            ingressShowToggleButtons,
            reprocessingGeofencing,
            reprocessingStatus,
            processingRatings,
            processingRatingsStatus,
        } = this.state;
        const { appState, userStore, raceStore, raceClassContestantStore, productStore, guestCartStore = {} } = this.props.stores;
        const {
            id: raceId,
            titleText,
            raceStartText,
            signupStartText,
            distanceText,
            dogsText,
            restText,
            totalFeeText,
            signupFeeText,
            cancelledText,
        } = this.props;
        const { isDevelopment, path, apiServer } = appState;
        const { language: appStateLanguage } = appState;
        const { user, isAdmin } = userStore;
        const { language = appStateLanguage } = user;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');
        const { race = {}, raceClassList, raceClassContestant, isRaceAdmin, isTimeTracker, isTdLeader, isRaceLeader, isTvRadioProducer, hasStarted } = raceStore;
        const { showResults, showTracking, hasTracking, hasResults, hasNews, hasLiveFeed, hideResults } = race;
        const isRaceMode = hasStarted || showResults;
        const { countriesTotal } = raceClassContestantStore;
        const { products } = productStore;

        return (<>
            {/* Race Validation - visible only to race admins */}
            {isRaceAdmin && (
                <RaceValidation stores={this.props.stores} />
            )}

            <div class='w-100 d-flex flex-sm-row flex-column' ref={c => { this.mainContainer = c; }}>
                {isRaceMode ? <>
                    <div class='w-100 d-flex flex-column'>
                        <div class='w-100 font-weight-lighter px-3 box-header d-flex flex-row justify-content-between'>
                            <span>{race.isCancelled && <><i class='fa-duotone fa-ban text-danger' /></>} {race.title} {race.isCancelled && `(${cancelledText})`}</span>
                        </div>
                        <div class='w-100 font-weight-lighter px-3 d-flex flex-row justify-content-between'>
                            <span>{util.isoDateCompact(race.startDate)}{raceLocalSuffix(race.startDate, race, 'time')} - {util.isoDateCompact(race.endDate)}{raceLocalSuffix(race.endDate, race, 'time')}</span>
                        </div>
                    </div>
                </> : <>
                    <div class='w-100 d-flex flex-column'>
                        <div class='d-flex px-3 w-100'>
                            {race.autoplayVideo && race.files?.length > 0 && (() => {
                                const file = race.files[0];
                                const poster = file.s3LinkStreamPreview1;
                                const hlsUrl = file.s3LinkStream;
                                if (hlsUrl) {
                                    return (
                                        <div class='video-player-wrapper d-flex flex-column w-100'>
                                            <video autoplay muted loop playsinline
                                                poster={poster} class='w-100'
                                                style='object-fit: cover;'
                                                ref={el => {
                                                    if (el && !el._hlsAttached) {
                                                        el._hlsAttached = true;
                                                        if (Hls.isSupported()) {
                                                            const hls = new Hls();
                                                            hls.loadSource(hlsUrl);
                                                            hls.attachMedia(el);
                                                        } else if (el.canPlayType('application/vnd.apple.mpegurl')) {
                                                            el.src = hlsUrl;
                                                        }
                                                    }
                                                }}
                                            />
                                        </div>
                                    );
                                }
                            })()}
                            {!(race.autoplayVideo && race.files?.some(f => f.s3LinkStream)) && (
                                <ImageScroller images={race.images} stores={this.props.stores} showImg={img => displayImg(img, this.props, '1920x')} />
                            )}
                        </div>
                        <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between'>
                            <span>
                                {race.isCancelled && <><i class='fa-duotone fa-ban text-danger' /></>} {race.title}  {race.isCancelled && `(${cancelledText})`}
                            </span>
                        </div>
                        <div class={`d-flex flex-sm-row flex-column mx-2`}>

                            <DateTileCard
                                stores={this.props.stores}
                                label={raceStartText}
                                date={race.startDate}
                                isCancelled={!!race.isCancelled}
                                postfix={raceLocalText(race.startDate, race, 'time') || undefined}
                                classesContainer={'flex-fill'}
                            />

                            {race.signupStartDate && <>
                                <DateTileCard
                                    stores={this.props.stores}
                                    label={signupStartText}
                                    date={race.signupStartDate}
                                    isCancelled={!!race.isCancelled}
                                    postfix={raceLocalText(race.signupStartDate, race, 'time') || undefined}
                                    classesContainer={'flex-fill'}
                                />
                            </>}
                        </div>
                    </div>
                </>}

                {/* <div class='w-100 d-flex flex-column'>
                    <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between'>
                        <Text id='race.history.title'>Your history</Text>
                    </div>
                    <div class={`d-flex flex-column mx-3 px-2 py-3 box-container ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}>
                        Your history
                    </div>
                </div> */}
            </div>

            {/* Stats section - visible to admins and race owners. Click opens detailed stats drawer. */}
            {(isAdmin || race.user === user.id) && (race.totalViews > 0 || race.weeklyStats?.length > 0) && (
                <div
                    class={`d-flex flex-row align-items-center flex-wrap mx-3 mt-2 px-3 py-2 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}
                    style='cursor: pointer;'
                    role='button'
                    title='Show detailed statistics'
                    onClick={this.openStats}
                >
                    <span class='text-muted font-weight-light me-2'>
                        <i class='fa-solid fa-chart-simple' /> Stats
                    </span>
                    <span class='badge text-bg-light me-2' title='Total views'>
                        <i class='fa-solid fa-eye' /> {race.totalViews}
                        {race.viewsTrend !== 0 && (
                            <span class={`ms-1 ${race.viewsTrend > 0 ? 'text-success' : 'text-danger'}`}>
                                {race.viewsTrend > 0 ? '+' : ''}{race.viewsTrend}%
                            </span>
                        )}
                    </span>
                    {race.totalLiveTrackingViews > 0 && (
                        <span class='badge text-bg-light me-2' title='Live tracking views'>
                            <i class='fa-solid fa-satellite-dish' /> {race.totalLiveTrackingViews}
                        </span>
                    )}
                    {race.totalResultViews > 0 && (
                        <span class='badge text-bg-light me-2' title='Result views'>
                            <i class='fa-solid fa-trophy' /> {race.totalResultViews}
                        </span>
                    )}
                    {race.weeklyStats?.length > 1 && (
                        <span class='badge text-bg-light me-2 py-1' title='Weekly trend'>
                            <Sparkline
                                data={race.weeklyStats}
                                valueField='views'
                                height={16}
                                barWidth={4}
                                barGap={1}
                                maxBars={12}
                            />
                        </span>
                    )}
                    <span class='text-muted ms-auto'>
                        <i class='fa-solid fa-chevron-right' />
                    </span>
                </div>
            )}

            {isRaceMode && <>
                <div class='w-100 d-flex flex-sm-row flex-column mt-1'>
                    {hasTracking && (showTracking || isAdmin || isRaceAdmin) && <button type='button'
                        class={`btn ${showTracking ? 'btn-primary' : 'btn-danger'} flex-fill rounded-pill mt-2 mx-3 my-0`}
                        onClick={this.goToTracking}>
                        <i class='fa-duotone fa-map-location-dot' /> <Text id='race.tracking'>Tracking</Text>
                    </button>}
                    {hasResults && (!hideResults || isAdmin || isRaceAdmin) && <button type='button'
                        class={`btn ${hideResults ? 'btn-danger' : 'btn-primary'} flex-fill rounded-pill mt-2 mx-3 my-0`}
                        onClick={this.goToResults}>
                        <i class='fa-duotone fa-list-ol' /> <Text id='race.results-menu'>Results</Text>
                    </button>}
                    {hasNews && <button type='button' class='btn btn-primary flex-fill rounded-pill mt-2 mx-3 my-0' onClick={this.goToNews}>
                        <i class='fa-duotone fa-newspaper' /> <Text id='race.news'>News</Text>
                    </button>}
                    {race.showStreaming && <button type='button' class='btn btn-primary flex-fill rounded-pill mt-2 mx-3 my-0' onClick={this.goToStreaming}>
                        <i class='fa-duotone fa-film' /> <Text id='race.streaming'>Streaming</Text>
                    </button>}
                    {hasLiveFeed && <button type='button' class='btn btn-primary flex-fill rounded-pill mt-2 mx-3 my-0' onClick={this.goToLive}>
                        <i class='fa-duotone fa-tower-broadcast' /> <Text id='race.live'>Live</Text>
                    </button>}
                    {race.link1 && <a target='_blank' href={race.link1} class='btn btn-primary flex-fill rounded-pill mt-2 mx-3 my-0'>
                        <i class='fa-duotone fa-link' /> {race.link1Text}
                    </a>}
                    {race.link2 && <a target='_blank' href={race.link2} class='btn btn-primary flex-fill rounded-pill mt-2 mx-3 my-0'>
                        <i class='fa-duotone fa-link' /> {race.link2Text}
                    </a>}
                    {race.link3 && <a target='_blank' href={race.link3} class='btn btn-primary flex-fill rounded-pill mt-2 mx-3 my-0'>
                        <i class='fa-duotone fa-link' /> {race.link3Text}
                    </a>}
                </div>

                {/* Weather Summary */}
                <RaceWeatherSummary stores={this.props.stores} raceId={race.id} />
            </>}

            {race.ingress && <div class='w-100 d-flex flex-sm-row flex-column mt-2'>
                <div class='w-100 d-flex flex-column my-2'>
                    <div class={`d-flex flex-column mx-3 px-3 py-3 box-container ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}>
                        <div
                            ref={c => this.ingressRef = c}
                            style={`${ingressExpanded ? 'max-height: 90vh; overflow-y: auto;' : `max-height: ${CONTENT_HEIGHT}px; overflow-y: hidden;`}`}>
                            <Markdown markdown={race.ingress} markedOpts={localUtil.getMarkdownOptions()} />
                            {race.body && <>
                                <Markdown markdown={localUtil.replaceImages(race.body, race.images)} markedOpts={localUtil.getMarkdownOptions()} />
                            </>}
                        </div>

                        {ingressShowToggleButtons && <>
                            <div class='d-flex flex-row justify-content-center'>
                                <button type='button' class='btn btn-link' onClick={() => this.setState({ ingressExpanded: !ingressExpanded })}>
                                    {ingressExpanded ?
                                        <>
                                            <Text id='input.read-less'>Read less</Text> <i class='fa-duotone fa-chevron-up' />
                                        </> : <>
                                            <Text id='input.read-more'>Read more</Text> <i class='fa-duotone fa-chevron-down' />
                                        </>}
                                </button>
                            </div>
                        </>}
                    </div>
                </div>
            </div>}

            {race.showStreaming && <StreamingList stores={this.props.stores} raceId={race.id} frontpage={1} classNames={'mt-3'} header={'Streaming'} />}

            {isRaceMode && <>
                <div class='w-100 d-flex flex-column mt-3'>
                    {/* <div class='w-100 d-flex flex-sm-row flex-column mt-3'> */}
                    {/* {hasNews && <div class='d-flex flex-column'>
                        <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between'>
                            <Text id='race.news'>News</Text>
                        </div>
                        <div class={`d-flex flex-column mx-3 px-0 py-3 box-container ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}>
                            <NewsList
                                key={`newsList-${race.id}`}
                                stores={this.props.stores}
                                raceId={race.id}
                                largeList={false}
                                showHeader={false}
                                limit={10}
                            />
                        </div>
                        <div class='w-100 d-flex justify-content-center'>
                            <a href={`/race/${race.id}/news`}><Text id='race.see-all-news'>See all news</Text> &raquo;</a>
                        </div>
                    </div>} */}
                    {hasResults && (!hideResults || isAdmin || isRaceAdmin) && <div class='d-flex flex-column'>
                        <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between'>
                            <Text id='race.results-menu'>Results</Text>
                        </div>
                        <div class={`d-flex flex-column mx-3 px-3 py-3 box-container ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}>
                            <RaceResultList
                                key={`raceResultsList-${raceId}`}
                                stores={this.props.stores}
                                id={raceId}
                            />
                        </div>
                    </div>}
                </div>
            </>}

            {products?.length > 0 && <>
                <div class='font-weight-lighter px-3 mt-4 box-header d-flex flex-row justify-content-between align-items-center'>
                    <span>{race.title} Shop</span>
                    {showGuestBasketButton({ userId: user?.id, canCheckout: guestCartStore.canCheckout }) && <button
                        type='button'
                        class='btn btn-sm btn-outline-primary rounded-pill'
                        onClick={this.openGuestCart}
                    >
                        <i class='fa-duotone fa-basket-shopping' /> <Text id='guestCart.basket'>Basket</Text>
                        {guestCartStore.count > 0 && <span class='badge text-bg-primary ms-1'>{guestCartStore.count}</span>}
                    </button>}
                </div>
                <div class={`d-flex flex-column mx-3 px-0`}>

                <ProductList stores={this.props.stores} products={products} race={race.id} classNames='mt-0' />

                {showSeeAllProductsLink({ currentCustomerId: appState.currentCustomer?.id, raceCustomerId: race.customer }) && <div class='w-100 d-flex justify-content-center'>
                    <a
                        href='/products'
                        type='button'
                        class='btn btn-primary rounded-pill mt-3 mx-3 my-0'
                    >
                        <i class='fa-duotone fa-shop' /> <Text id='shop.see-all-products'>See all products</Text>
                    </a>
                </div>}
                </div>
            </>}

            <div class='w-100 d-flex flex-sm-row flex-column mt-4'>
                <div class='w-100 d-flex flex-column position-relative'>
                    {/* <div class='d-flex flex-row position-absolute justify-content-between overflow-auto no-scrollbar' style='max-width: 50%; top: -12px; right: 15px;'>
                        {countriesTotal && Object.keys(countriesTotal).sort(this.sortByTotal).map(country => {
                            return (<>
                                <div class='d-flex flex-row justify-content-center align-items-center position-relative'>
                                    {localUtil.getFlagSvgByCountryCode(country, 45, false, 'rounded-lg', 'border: 2px solid #ffffff;')}
                                    <div class='position-absolute bg-primary text-white rounded-lg px-2' style='bottom: 0px; left: 0px; line-height: 16px; border: 2px solid #ffffff;'>
                                        <small>
                                            {countriesTotal[country]}
                                        </small>
                                    </div>
                                </div>
                            </>);
                        })}
                    </div> */}
                    <RaceClassList
                        stores={this.props.stores}
                        raceClasses={raceClassList}
                        hideEmpty={true}
                    />
                    {/* <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between'>
                        <Text id='race.classes.title'>Classes</Text>
                    </div>
                    <div class={`d-flex flex-column mx-3 px-2 py-3 box-container ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}>
                    </div> */}
                </div>

                {/* <div class='w-100 d-flex flex-column my-2'>
                    <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between'>
                        <Text id='race.map.title'>Map</Text>
                    </div>
                    <div class={`d-flex flex-column mx-3 px-2 py-3 box-container ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}>
                        Map
                    </div>
                </div> */}
            </div>

            {isRaceMode && <>
                <div class='w-100 d-flex flex-sm-row flex-column mt-1'>
                    {hasTracking && (showTracking || isAdmin || isRaceAdmin) && <button type='button'
                        class={`btn ${showTracking ? 'btn-primary' : 'btn-danger'} flex-fill rounded-pill mt-2 mx-3 my-0`}
                        onClick={this.goToTracking}>
                        <i class='fa-duotone fa-map-location-dot' /> <Text id='race.tracking'>Tracking</Text>
                    </button>}
                    {hasResults && (!hideResults || isAdmin || isRaceAdmin) && <button type='button'
                        class={`btn ${hideResults ? 'btn-danger' : 'btn-primary'} flex-fill rounded-pill mt-2 mx-3 my-0`}
                        onClick={this.goToResults}>
                        <i class='fa-duotone fa-list-ol' /> <Text id='race.results-menu'>Results</Text>
                    </button>}
                    {hasNews && <button type='button' class='btn btn-primary flex-fill rounded-pill mt-2 mx-3 my-0' onClick={this.goToNews}>
                        <i class='fa-duotone fa-newspaper' /> <Text id='race.news'>News</Text>
                    </button>}
                    {race.showStreaming && <button type='button' class='btn btn-primary flex-fill rounded-pill mt-2 mx-3 my-0' onClick={this.goToStreaming}>
                        <i class='fa-duotone fa-film' /> <Text id='race.streaming'>Streaming</Text>
                    </button>}
                    {hasLiveFeed && <button type='button' class='btn btn-primary flex-fill rounded-pill mt-2 mx-3 my-0' onClick={this.goToLive}>
                        <i class='fa-duotone fa-tower-broadcast' /> <Text id='race.live'>Live</Text>
                    </button>}
                    {race.link1 && <a target='_blank' href={race.link1} class='btn btn-primary flex-fill rounded-pill mt-2 mx-3 my-0'>
                        <i class='fa-duotone fa-link' /> {race.link1Text}
                    </a>}
                    {race.link2 && <a target='_blank' href={race.link2} class='btn btn-primary flex-fill rounded-pill mt-2 mx-3 my-0'>
                        <i class='fa-duotone fa-link' /> {race.link2Text}
                    </a>}
                    {race.link3 && <a target='_blank' href={race.link3} class='btn btn-primary flex-fill rounded-pill mt-2 mx-3 my-0'>
                        <i class='fa-duotone fa-link' /> {race.link3Text}
                    </a>}
                </div>

            </>}

            {!isRaceMode && <>
                <div class='w-100 d-flex flex-sm-row flex-column mt-5'>
                    <div class='w-100 d-flex flex-column'>
                        <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between'>
                            <Text id='race.news'>News</Text>
                        </div>
                        <div class={`d-flex flex-column mx-3 px-0 py-3 box-container ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}>
                            <NewsList
                                key={`newsList-${race.id}`}
                                stores={this.props.stores}
                                raceId={race.id}
                                largeList={false}
                                showHeader={false}
                                limit={3}
                            />
                            <div class='d-flex flex-row justify-content-center border-top mt-2 pt-2'>
                                <a href={`/race/${race.id}/news`}>
                                    <Text id='race.see-all-news'>See all news</Text> &raquo;
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </>}

            {/* Course / info files with «Vis på kart»; sits below the news on request. */}
            {race.files && race.files.length > 0 && (
                <RaceFileList stores={this.props.stores} files={race.files} raceId={race.id} classNames='mt-5' />
            )}

            {isTimeTracker && <>
                <div class='w-100 d-flex flex-sm-row flex-column mt-5'>
                    <div class='w-100 d-flex flex-column'>
                        <Localizer>
                            <GuiList
                                title={<span class='text-danger font-weight-normal'><Text id='race.timetracker'>Race timetracker</Text></span>}
                                stores={this.props.stores}
                                holdingStore={raceStore}
                                view={this.goToTimetrackerPage}
                                list={timetrackerList}
                                elTitle={e => e.title}
                                elInfo1={e => ''}
                                elInfo2={e => ''}
                                elInfo3={e => ''}
                                hideEmpty={true}
                                showEmptyImage={false}
                                showFilterBox={false}
                                showCevron={true}
                                // editElement={editElement}
                            />
                        </Localizer>
                    </div>
                </div>
            </>}
            {(isRaceLeader || isTdLeader) && <>
                <div class='w-100 d-flex flex-sm-row flex-column mt-5'>
                    <div class='w-100 d-flex flex-column'>
                        <Localizer>
                            <GuiList
                                title={<span class='text-danger font-weight-normal'><Text id='race.raceleader'>Race Leader / TD Leader</Text></span>}
                                stores={this.props.stores}
                                holdingStore={raceStore}
                                view={this.goToRaceleaderPage}
                                list={raceleaderList}
                                elTitle={e => e.title}
                                elInfo1={e => ''}
                                elInfo2={e => ''}
                                elInfo3={e => ''}
                                hideEmpty={true}
                                showEmptyImage={false}
                                showFilterBox={false}
                                showCevron={true}
                                // editElement={editElement}
                            />
                        </Localizer>
                    </div>
                </div>
            </>}

            {isTvRadioProducer && <>
                <div class='w-100 d-flex flex-sm-row flex-column mt-5'>
                    <div class='w-100 d-flex flex-column'>
                        <Localizer>
                            <GuiList
                                title={<span class='text-danger font-weight-normal'><Text id='race.tv-producer'>TV/Radio Producer</Text></span>}
                                stores={this.props.stores}
                                holdingStore={raceStore}
                                view={this.goToTvRadioProducerPage}
                                list={tvRadioProducerList}
                                elTitle={e => e.title}
                                elInfo1={e => ''}
                                elInfo2={e => ''}
                                elInfo3={e => ''}
                                hideEmpty={true}
                                showEmptyImage={false}
                                showFilterBox={false}
                                showCevron={true}
                            />
                        </Localizer>
                    </div>
                </div>
            </>}

            {isRaceAdmin && <>
                <div class='w-100 d-flex flex-sm-row flex-column mt-5'>
                    <div class='w-100 d-flex flex-column'>
                        <Localizer>
                            <GuiList
                                title={<span class='text-danger font-weight-normal'><Text id='race.admin'>Race admin</Text></span>}
                                stores={this.props.stores}
                                holdingStore={raceStore}
                                view={this.goToAdminPage}
                                list={adminList}
                                elTitle={e => e.title}
                                elInfo1={e => ''}
                                elInfo2={e => ''}
                                elInfo3={e => ''}
                                hideEmpty={true}
                                showEmptyImage={false}
                                showFilterBox={false}
                                showCevron={true}
                                // editElement={editElement}
                            />
                        </Localizer>
                    </div>
                </div>
            </>}

            {isAdmin && <>
                <div class='w-100 d-flex flex-sm-row flex-column mt-5'>
                    <div class='w-100 d-flex flex-column'>
                        <div class='font-weight-lighter px-3 box-header text-warning'>
                            <Text id='race.super-admin'>Super Admin</Text>
                        </div>
                        <div class={`d-flex flex-column mx-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}>
                            <button
                                type='button'
                                class='btn btn-link text-warning text-start d-flex align-items-center justify-content-between px-3 py-3'
                                onClick={this.reprocessGeofencing}
                                disabled={reprocessingGeofencing}
                            >
                                <span>
                                    <i class={`fa-duotone ${reprocessingGeofencing ? 'fa-spinner fa-spin' : 'fa-rotate'} me-2`} />
                                    {reprocessingStatus || <Text id='race.reprocess-geofencing'>Reprocess Geofencing</Text>}
                                </span>
                                {!reprocessingGeofencing && <i class='fa-solid fa-chevron-right' />}
                            </button>
                            <button
                                type='button'
                                class='btn btn-link text-warning text-start d-flex align-items-center justify-content-between px-3 py-3'
                                onClick={this.processMusherRatings}
                                disabled={processingRatings}
                            >
                                <span>
                                    <i class={`fa-duotone ${processingRatings ? 'fa-spinner fa-spin' : 'fa-ranking-star'} me-2`} />
                                    {processingRatingsStatus || <Text id='race.process-musher-ratings'>Process Musher Rankings</Text>}
                                </span>
                                {!processingRatings && <i class='fa-solid fa-chevron-right' />}
                            </button>
                        </div>
                    </div>
                </div>
            </>}

            {resultList?.length > 0 && <div class='w-100 d-flex flex-sm-row flex-column mt-4'>
                <div class='w-100 d-flex flex-column'>
                    <Localizer>
                        <GuiList
                            title={<Text id='race.results'>Race results</Text>}
                            stores={this.props.stores}
                            holdingStore={raceStore}
                            view={this.goToPage}
                            list={resultList}
                            elTitle={e => e.danger ? <span class='text-danger'>{e.title}</span> : e.title}
                            elInfo1={e => ''}
                            elInfo2={e => ''}
                            elInfo3={e => ''}
                            hideEmpty={false}
                            showEmptyImage={false}
                            showFilterBox={false}
                            showCevron={true}
                            // editElement={editElement}
                        />
                    </Localizer>
                </div>
            </div>}

            <div class='w-100 d-flex flex-sm-row flex-column mt-4'>
                <div class='w-100 d-flex flex-column'>
                    <Localizer>
                        <GuiList
                            title={<Text id='race.about'>About the race</Text>}
                            stores={this.props.stores}
                            holdingStore={raceStore}
                            view={this.viewText}
                            list={infoList}
                            elTitle={e => e.title}
                            elInfo1={e => ''}
                            elInfo2={e => ''}
                            elInfo3={e => ''}
                            hideEmpty={true}
                            showEmptyImage={false}
                            showFilterBox={false}
                            showCevron={true}
                            // editElement={editElement}
                        />
                    </Localizer>
                </div>
            </div>

            <div class='w-100 d-flex flex-sm-row flex-column mt-4 px-3'>
                <button
                    type='button'
                    class='btn btn-primary btn-lg btn-block rounded-pill'
                    onClick={this.addToCalendar}
                >
                    <i class='fa-solid fa-calendar-plus me-1' /> <Text id='action.add-to-calendar'>Add to calendar</Text>
                </button>
            </div>

        </>);
    }
}

export default RaceDetail;



